import en from './locales/en.json'
import zh from './locales/zh.json'
import zhTW from './locales/zh-TW.json'
import ja from './locales/ja.json'
import ko from './locales/ko.json'
import fr from './locales/fr.json'
import de from './locales/de.json'
import es from './locales/es.json'

export default defineI18nConfig(() => ({
  legacy: false,
  fallbackLocale: 'en' as any,
  availableLocales: ['en', 'zh', 'zh-TW', 'ja', 'ko', 'fr', 'de', 'es'] as any,
  messages: {
    en,
    zh,
    'zh-TW': zhTW,
    ja,
    ko,
    fr,
    de,
    es
  } as any
})) 